import type { CSSProperties } from 'react';
import type { PresetOut } from '@/api/types';
import { sectionType, Thumb } from '@/design-system';
import { cx } from '@/lib/cx';
import s from './library.module.css';

/** "16 / 8" → 2: a section ratio as a number, for the contain-fit below. */
export function ratioValue(ratio: string): number {
  const [w, h] = ratio.split('/').map((x) => Number(x.trim()));
  return w && h ? w / h : 2;
}

/**
 * A preset's picture (DESIGN_SPEC §9 C6, PLAN D21): a real catalog preset's rendered screenshot when the
 * QA renderer has made one; otherwise (parametric and demo presets, or a render still pending) the
 * design's wireframe of its layout, colour mode and mirror, at its section's gallery ratio, contained.
 */
export function PresetArt({ preset, ratio, className }: { preset: Pick<PresetOut, 'thumbnail_url' | 'layout' | 'color_mode' | 'mirrored' | 'section_type'>; ratio?: string; className?: string }) {
  const r = ratio ?? sectionType(preset.section_type).galleryRatio;
  return (
    <div className={cx(s.artFit, className)} style={{ '--ratio': ratioValue(r) } as CSSProperties}>
      {preset.thumbnail_url ? (
        <img className={s.artShot} src={preset.thumbnail_url} alt="" loading="lazy" style={{ aspectRatio: r }} />
      ) : (
        <Thumb layout={preset.layout} mode={preset.color_mode} mirrored={preset.mirrored} ratio={r} className={s.artWire} />
      )}
    </div>
  );
}
